import { type FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'

export const ZapierIntegrationSuccess: FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Go to the Zapier Integration now' onButtonClick={() => navigate(0)} />
}
